// extracted by mini-css-extract-plugin
export default {"subtitle":"DerasarNotificationSettings_subtitle__Njcaz","loading":"DerasarNotificationSettings_loading__AeKAA"};